import React from "react";
import { computeEffectivePrice } from "../../../../services/TransferService";

const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

const TransferResultCard = ({ transferData, onBookNow }) => {
	const {
		vehicle_img,
		vehicle_type_name,
		vehicle_type_des,
		make,
		model,
		max_pax,
		max_lugg,
		meet_greet,
		trasnfer_type,
		water_bottle,
		wait_time,
		cancel_policy,
	} = transferData;

	const { effective, original, discounted } = computeEffectivePrice(transferData);

	return (
		<div className="card mb-4">
			<div style={{ display: "flex", alignItems: "flex-start", gap: "1.25rem", padding: "1rem", flexWrap: "wrap" }}>
				<div
					style={{
						flex: "0 0 auto",
						width: "150px",
						height: "150px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<img
						src={vehicle_img}
						alt={vehicle_type_name}
						style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
					/>
				</div>
				<div style={{ flex: "1 1 320px", minWidth: 0 }}>
					<div className="d-flex justify-content-between flex-wrap">
						<div>
							<h4 className="mb-1">{vehicle_type_des}</h4>
							<span className="badge light border border-primary text-primary text-uppercase mb-2">
								{vehicle_type_name}
							</span>
							<div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: "1rem" }}>
								<span>
									<i className="fa fa-user text-primary me-1" />
									Upto {max_pax} passengers
								</span>
								<span>
									<i className="fa fa-suitcase text-primary me-1" />
									{max_lugg} Luggage's
								</span>
								<span>
									<strong>Vehicle Type:</strong> {make} {model}
								</span>
								{trasnfer_type && (
									<span>
										<strong>Transfer Type:</strong> {capitalize(trasnfer_type)}
									</span>
								)}
							</div>
							<div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: "1.25rem" }}>
								{meet_greet === "yes" && (
									<span>
										<strong>Meet &amp; Greet:</strong> <i className="fa fa-check text-success ms-1" />
									</span>
								)}
								{water_bottle === "yes" && (
									<span>
										<strong>Water Bottle:</strong> <i className="fa fa-check text-success ms-1" />
									</span>
								)}
								<span>
									<strong>Cancellation Policy:</strong> {cancel_policy ? `${cancel_policy} hours` : "N/A"}
								</span>
								<span>
									<strong>Wait Time:</strong> {wait_time ? `${wait_time} minutes` : "N/A"}
								</span>
							</div>
						</div>
						<div className="text-md-end mt-3 mt-md-0">
							{discounted && (
								<>
									<div className="text-muted">Normal Price</div>
									<div className="text-decoration-line-through text-muted">AU$ {original.toFixed(2)}</div>
								</>
							)}
							<div className="text-muted mt-1">Agency Price</div>
							<div className="fs-24 fw-bold">AU$ {effective.toFixed(2)}</div>
						</div>
					</div>
					<div className="d-flex justify-content-end mt-3">
						<button type="button" className="btn btn-primary rounded-pill px-4" onClick={onBookNow}>
							Book now <i className="fa fa-paper-plane ms-2" />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TransferResultCard;
